import { Backdrop as MuiBackdrop, styled } from '@material-ui/core'

export const Backdrop = styled(MuiBackdrop)({
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
})
